import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/131988618/d25dafb9-87f8-4b6a-a205-57a851d47b5e",
        "alt": "An image displaying a Radio with a radio and label."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Radio: A selection control.`}</li>
      <li parentName="ul">{`Label: A description for the radio. `}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the radio component to enable users to select a single option from a list.`}</p>
    <p>{`For scenarios that allow for multiple selections, use the `}<a parentName="p" {...{
        "href": "/components/Checkbox"
      }}>{`Checkbox`}</a>{` component instead. Keep the radio label descriptive and concise: aim for no more than 3 words. Write labels in sentence case and without ending in punctuation.`}</p>
    <h3>{`Grouping`}</h3>
    <p>{`To group related radio components together in a list, use the `}<a parentName="p" {...{
        "href": "/components/Stack"
      }}>{`Stack`}</a>{` and `}<a parentName="p" {...{
        "href": "/components/FormControl"
      }}>{`FormControl`}</a>{` components. When rendering a group of radio components, make sure to consider all potential option. Remember to include "None" or "Other" options when necessary. `}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/131988618/151c50cb-c3ac-4790-901d-a5be38fad46e" />
    <Caption mdxType="Caption">
        Ensure radio options are are mutually exclusive. Include "None" or "Other" options when necessary. 
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/131988618/5d25cfee-bf8e-4b93-93da-5dd40f38f3be" />
    <Caption mdxType="Caption">
        Don't overlap or leave out potential radio options from the list.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/131988618/433d5deb-0395-4d24-8f5d-513178d9e944" />
    <Caption mdxType="Caption">
        When used in groups, order the radio options in a logical order (e.g. smallest to largest).
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/131988618/9d3f4639-c064-4b18-bcce-89a05a29b4e1" />
    <Caption mdxType="Caption">
        Don't order radio options without logic in a group.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`States`}</h3>
    <p>{`Radios have static dimensions and three different states: default, checked, and disabled.`}</p>
    <img src="https://github.com/primer/brand/assets/131988618/94a893a6-0063-4204-a7ab-da7b5aaaa96b" />
    <h2>{`Accessibility`}</h2>
    <p>{`Please use `}<a parentName="p" {...{
        "href": "/components/FormControl"
      }}>{`FormControl`}</a>{` to render a standard radio input field. If using standalone, it should always be accompanied by a corresponding `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` to improve support for assistive technologies.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Checkbox"
        }}>{`Checkbox`}</a>{`: Use the checkbox component to select one or more options of a limited number of choices.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Select"
        }}>{`Select`}</a>{`: Use the select component to enable selection of one option from a list.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/FormControl"
        }}>{`FormControl`}</a>{`: Use the form control component to display form inputs alongside labels, validation and more.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Stack"
        }}>{`Stack`}</a>{`: Use the stack component to create a layout for its immediate children along the vertical or horizontal axis.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      